import { render, staticRenderFns } from "./ListRightButton.vue?vue&type=template&id=ccfab07e&"
import script from "./ListRightButton.vue?vue&type=script&lang=js&"
export * from "./ListRightButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports